var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "widM txtC padS marTX padBX",
        staticStyle: {
          "background-color": "#fcfdff",
          "border-radius": "25px",
          border: "solid 1px #e1e8f2"
        }
      },
      [
        _c("dl", { staticClass: "marTX" }, [
          _c("dt", [
            _c("p", { staticClass: "fntH6" }, [
              _c(
                "b",
                {
                  staticClass: "osResTag",
                  staticStyle: {
                    color: "#fff",
                    background: "#3872d3",
                    width: "8em",
                    padding: ".7em"
                  }
                },
                [_vm._v("신청 기간")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "padTM" }, [
            _c("span", { staticClass: "fntP" }, [
              _vm._v("4월 19일(수) 오전 10시 ~ 4월 22일(토) 오후 11시 50분 "),
              _c("br", { staticClass: "moOnly" }),
              _vm._v("(선착순)")
            ])
          ]),
          _vm._v(" "),
          _c("dt", { staticClass: "marTL" }, [
            _c("p", { staticClass: "fntH6" }, [
              _c(
                "b",
                {
                  staticClass: "osResTag",
                  staticStyle: {
                    color: "#fff",
                    background: "#3872d3",
                    width: "8em",
                    padding: ".7em"
                  }
                },
                [_vm._v("참여 방법")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "padTM" }, [
            _c(
              "div",
              {
                staticClass: "widS txtL fntP",
                staticStyle: { "max-width": "550px" }
              },
              [
                _c("ol", [
                  _c(
                    "li",
                    {
                      staticStyle: {
                        "text-indent": "-0.9em",
                        "padding-left": "0.9em"
                      }
                    },
                    [
                      _vm._v(
                        "1. 본 이벤트 페이지에서 이벤트 신청 후, 팝업창에서 정상 접수 여부를 바로 확인"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("li", { staticClass: "padTSM" }, [
                    _c(
                      "span",
                      {
                        staticClass: "disIb",
                        staticStyle: {
                          "text-indent": "-0.9em",
                          "padding-left": "0.9em"
                        }
                      },
                      [
                        _vm._v(
                          "2. 이벤트 기간 내(4/19(수) 오전 10시 ~ 5월 글리스터 출시 프로모션 첫 날) 3가지 미션을 수행"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "padSM marTS",
                        staticStyle: {
                          background: "#eff5ff",
                          "border-radius": "10px"
                        }
                      },
                      [
                        _c("li", [
                          _c("strong", [_vm._v("[미션 1]")]),
                          _vm._v(
                            "  4/19(수) ~ 4/25(화) 암웨이 인스타그램에서 글리스터 출시영상과 카드뉴스를 찾아 리그램"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("strong", [_vm._v("[미션 2]")]),
                          _vm._v(
                            "  4/27(목) ~ 5/9(화) 글리스터 신제품 샘플을 체험 후, 본인의 인스타그램에 제품을 사용하는 사진과 함께 체험후기를 업로드\n                "
                          ),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "· 신제품 샘플 종류 및 업로드 관련 세부 내용은 추후 별도 공지 예정입니다."
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                "· 신제품 샘플은 각 팀의 팀장이 4/27(목) ~ 5/2(화) 기간 내에 가까운 ABC에 방문하여 수령 후 팀원들과 함께 체험합니다. 지정된 기간 이후에는 수령이 불가능합니다."
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("strong", [_vm._v("[미션 3]")]),
                          _vm._v(
                            "  5월 글리스터 출시 프로모션 첫 날, 프로모션 세트를 구입(세부 내용 추후 별도 공지 예정)"
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "padTSM" }, [
                    _vm._v(
                      "3. 3가지 미션 완료 시, 글리스터 프로액션 컴플리트 치약(여행용 사이즈) 제품을 증정\n            "
                    ),
                    _c("ul", { staticClass: "colorGray padTS" }, [
                      _c("li", [
                        _vm._v(
                          "※ 5월 글리스터 출시 프로모션 첫 날 프로모션 세트를 구입하신 경우에 한하여 증정됩니다."
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "※ 5월 글리스터 출시 프로모션 첫 날부터 5월 31일(수)까지 한국암웨이 홈페이지 또는 모바일 앱에서 암웨이 제품을 구매할 경우에 한하여 구매한 제품과 함께 합배송됩니다."
                        )
                      ])
                    ])
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("dt", { staticClass: "marTL" }, [
            _c("p", { staticClass: "fntH6" }, [
              _c(
                "b",
                {
                  staticClass: "osResTag",
                  staticStyle: {
                    color: "#fff",
                    background: "#3872d3",
                    width: "8em",
                    padding: ".7em"
                  }
                },
                [_vm._v("유의 사항")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "padTM" }, [
            _c(
              "div",
              {
                staticClass: "widS txtL fntP",
                staticStyle: { "max-width": "550px" }
              },
              [
                _c(
                  "ul",
                  {
                    staticStyle: {
                      "text-indent": "-.5em",
                      "padding-left": ".5em"
                    }
                  },
                  [
                    _c("li", [
                      _vm._v(
                        "- 본 이벤트는 한정수량으로 조기 종료될 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "- 본 이벤트는 2023년 3월 1일에 시작된 A7070 [리더의 관계] 참가자 대상으로 진행되는 이벤트이며 참가하더 라도 A7070 참가자가 아니거나 소속된 팀의 팀장이 본 이벤트에 참여하지 않는\n            경우에는 추후 증정품 제공이 취소될 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "- 본 이벤트의 두번째 미션에 사용할 글리스터 신제품 샘플은 각 팀의 팀장이 4/27(목) ~ 5/2(화) 기간 내에 가까운 ABC에 방문하여 수령 후 팀원들과 함께 체험합니다. 지정된 기간 이후에는\n            수령이 불가능합니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "- 본 이벤트의 세번째 미션은 글리스터 출시 프로모션 첫 날 프로모션 세트를 구매하신 경우에 한하여 증정품이 제공됩니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "- 본 이벤트에 참가하기 위해서는 ABO 번호(또는 소비자 번호)가 필요합니다. 이벤트에 참여하더라도 잘못된 ABO 번호(또는 소비자 번호)를 기입하는 경우 추후 증정품 제공이 취소 또는 전달이 불가능할\n            수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "- 소비자 번호의 확인 방법은 본 페이지 맨 하단에서 확인 할 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "- 본 이벤트의 증정품 배송은 5월 글리스터 출시 프로모션 첫 날부터 5월 31일(수)까지 암웨이 제품을 구매할 경우에 한하여 구매한 제품과 함께 합배송됩니다. 이때 주문 채널은 암웨이\n            홈페이지(www.amway.co.kr) 또는 모바일 앱을 통한 배달 주문만 가능합니다."
                      ),
                      _c("br", { staticClass: "pcOnly" }),
                      _vm._v(
                        "(스마트 오더, 장바구니 스마트 오더, 전화 및 ARS 주문, 온라인 팩스 주문 및\n            ABC픽업예약주문, ABC 현장주문 불가) "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "- 본 이벤트 정상 접수 여부는 팝업창을 통해 확인하실 수 있습니다."
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d667f8e8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d667f8e8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/a7070-glister/component/guide.vue
// module id = null
// module chunks = 